import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class UCLinkIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()

        return [
            <g transform="translate(7 0.144)">
                <circle cx="17.5" cy="17.5" r="17.5" transform="translate(-7 -0.144)" fill="#e5e9ed"/>
                <path d="M11728.025,2377.372l-.743-.743a4.393,4.393,0,0,1,0-6.2l4.825-4.827a4.4,4.4,0,0,1,6.209,0l.743.743a1.24,1.24,0,0,1-1.754,1.752l-.743-.743a1.914,1.914,0,0,0-2.7,0l-4.827,4.828a1.914,1.914,0,0,0,0,2.7l.743.743a1.916,1.916,0,0,0,2.7,0c.012-.012.024-.024.036-.034l2.547-2.354a1.24,1.24,0,0,1,1.682,1.823l-2.532,2.337a4.382,4.382,0,0,1-3.085,1.262h-.01A4.364,4.364,0,0,1,11728.025,2377.372Zm6.31-6.312-.743-.743a1.24,1.24,0,0,1,1.755-1.752l.74.743a1.91,1.91,0,0,0,2.7,0l4.825-4.828a1.91,1.91,0,0,0,0-2.7l-.742-.741a1.909,1.909,0,0,0-2.692-.01l-2.039,2.127a1.239,1.239,0,1,1-1.789-1.716l2.048-2.137a.131.131,0,0,0,.019-.02,4.392,4.392,0,0,1,6.207,0l.743.741a4.394,4.394,0,0,1,0,6.207l-4.825,4.827a4.388,4.388,0,0,1-6.209,0Z" transform="translate(-11725.976 -2350.823)" fill={color}/>
            </g>
        ]
    }
    getViewBox = () => '0 0 35 35'
}
